import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/pages/site/LegalPage";

export const Route = createFileRoute("/terms")({
  component: () => <LegalPage slug="terms" />,
});
